import { render, staticRenderFns } from "./totaisPorCategoria.vue?vue&type=template&id=91b05b5c"
import script from "./totaisPorCategoria.ts?vue&type=script&lang=js&external"
export * from "./totaisPorCategoria.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91b05b5c')) {
      api.createRecord('91b05b5c', component.options)
    } else {
      api.reload('91b05b5c', component.options)
    }
    module.hot.accept("./totaisPorCategoria.vue?vue&type=template&id=91b05b5c", function () {
      api.rerender('91b05b5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/dashboard/totaisPorCategoria.vue"
export default component.exports